/* eslint-disable */

import * as THREE from 'three'
import Hexagones from './Hexagones.js'
import Particles from './Particles.js'
import PointOfInterest from './PointOfInterest.js'
import EventEmitter from './EventEmitter.js'

class Globe extends EventEmitter
{
    /**
     * Constructor
     */
    constructor(options = {})
    {
        super(options)

        // Options
    	this.time = options.time
    	this.camera = options.camera
        this.mapMaskImage = typeof options.mapMaskImage !== 'undefined' ? options.mapMaskImage : ''
        this.POICoordinates = typeof options.POICoordinates !== 'undefined' ? options.POICoordinates : []

        // Container
        this.container = new THREE.Object3D()

        // Hexagones
    	this.hexagones = new Hexagones({
            mapMaskImage: this.mapMaskImage
        })
        this.hexagones.on('ready', () =>
        {
            this.trigger('ready')
        })
        this.container.add(this.hexagones.container)
        this.hexagones.container.renderOrder = 0

        // Particles
    	this.particles = new Particles({ time: this.time })
        this.container.add(this.particles.container)

        // Point of interest
        this.pointsOfInterest = []

        for(let i = 0; i < this.POICoordinates.length; i++)
        {
            const _coordinates = this.POICoordinates[i]
            const pointOfInterest = new PointOfInterest({ time: this.time })
            const xyz = this.latLngToXYZ(_coordinates[0], _coordinates[1], 1.015)

            pointOfInterest.container.position.x = xyz.x
            pointOfInterest.container.position.y = xyz.y
            pointOfInterest.container.position.z = xyz.z
            pointOfInterest.container.lookAt(new THREE.Vector3())

            this.container.add(pointOfInterest.container)

            this.pointsOfInterest.push(pointOfInterest)
        }

    }

    /**
     * LatLngToXYZ
     */
    latLngToXYZ(lat, lng, radius)
    {
        const phi = (90 - lat) * (Math.PI / 180)
        const theta = lng * (Math.PI/180)

        const x = - (radius * Math.sin(phi) * Math.cos(theta))
        const z = (radius * Math.sin(phi) * Math.sin(theta))
        const y = (radius * Math.cos(phi))

        return { x, y, z }
    }

    /**
     * Update
     */
    update()
    {
    	this.particles.update()

        for(let i = 0; i < this.pointsOfInterest.length; i++)
        {
            const _pointOfInterest = this.pointsOfInterest[i]
            _pointOfInterest.update()
        }
    }
}

export default Globe



// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/Globe.js